export default "__VITE_ASSET__BlGwUuO8__"